import { Grid, Typography } from '@mui/material'
import type { Product } from '@/content/types'
import { relatedProducts } from '@/content/products'
import { ProductCard } from './ProductCard'

/** "Related Products" grid — other items from the same category. */
export function RelatedProducts({ product }: { product: Product }) {
  const related = relatedProducts(product)
  if (related.length === 0) return null

  return (
    <>
      <Typography variant="h3" component="h2" sx={{ mb: { xs: 4, md: 6 } }}>
        Related Products
      </Typography>
      <Grid container spacing={{ xs: 3, md: 4 }}>
        {related.map((p) => (
          <Grid key={p.slug} size={{ xs: 12, sm: 6, md: 3 }}>
            <ProductCard product={p} />
          </Grid>
        ))}
      </Grid>
    </>
  )
}
